import { useLanguage } from "../i18n/LanguageContext";
import { Logo } from "./Logo";

export const Footer = () => {
  const { t } = useLanguage();

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="relative bg-[#050B14] border-t border-[rgba(212,175,55,0.15)]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <Logo />
          <p className="mt-6 text-sm text-slate-400 font-light leading-relaxed max-w-xs">{t.footer.tagline}</p>
        </div>
        <div>
          <p className="font-label text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-6">{t.footer.navTitle}</p>
          <div className="flex flex-col gap-3">
            {[
              { id: "fleet", label: t.nav.fleet, testid: "footer-fleet-link" },
              { id: "destinations", label: t.nav.destinations, testid: "footer-destinations-link" },
              { id: "philosophy", label: t.nav.philosophy, testid: "footer-philosophy-link" },
              { id: "contact", label: t.nav.contact, testid: "footer-contact-link" },
            ].map((l) => (
              <button
                key={l.id}
                onClick={() => scrollTo(l.id)}
                data-testid={l.testid}
                className="text-left text-sm text-slate-400 hover:text-[#D4AF37] transition-colors duration-300 w-fit"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="font-label text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-6">{t.footer.contactTitle}</p>
          <div className="text-sm text-slate-400 font-light space-y-2">
            <p className="text-[#F7F5F0]">DLD TURIZAM j.d.o.o.</p>
            <p>Ulica Maka Dizdara 14, 44000 Sisak, Hrvatska</p>
            <p>OIB: 02179948320</p>
            <a href="mailto:info@malta-adria.eu" className="block hover:text-[#D4AF37] transition-colors duration-300" data-testid="footer-email-link">
              info@malta-adria.eu
            </a>
            <a href="https://wa.me/35679637742" target="_blank" rel="noopener noreferrer" className="block hover:text-[#D4AF37] transition-colors duration-300" data-testid="footer-phone-link">
              +356 7963 7742
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-[rgba(212,175,55,0.1)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-wrap items-center justify-between gap-4">
          <p className="font-label text-[10px] tracking-[0.2em] uppercase text-slate-500" data-testid="footer-copyright">
            © 2026 DLD TURIZAM j.d.o.o. — {t.footer.rights}
          </p>
          <p className="font-label text-[10px] tracking-[0.3em] uppercase text-slate-600">www.malta-adria.eu</p>
        </div>
      </div>
    </footer>
  );
};
